export default "assets/images/icons/youtube-f042f598.svg";